import {reportError} from 'app/client/models/errors';
import {ApiError} from 'app/common/ApiError';
import {Observable} from 'grainjs';

/**
 * Sets the error details on `errObs` if `err` is a 4XX error. Otherwise, reports the
 * error via the Notifier instance.
 */
export function handleFormError(err: unknown, errObs: Observable<string>) {
  if (
    err instanceof ApiError &&
    err.status >= 400 &&
    err.status < 500
  ) {
    errObs.set(err.details?.userError ?? err.message);
  } else {
    reportError(err as Error | string);
  }
}
